export const AppName = "Toxigent";
export const AppData = {};

export const WikipediaAPI = {
    search: "https://en.wikipedia.org/w/api.php?origin=*&action=query&formatversion=2&generator=prefixsearch&gpslimit=3&prop=pageimages%7Cpageterms&piprop=thumbnail&pithumbsize=150&pilimit=3&redirects=&wbptterms=description&format=json&gpssearch=",
    page: "https://en.wikipedia.org/?curid="
}
